import { CHART_COLORS, CHART_DIMENSIONS } from './constants';

// Common chart configurations for Plotly
export const chartConfigs = {
  // Responsive configuration for all charts
  responsive: {
    responsive: true,
    displayModeBar: true,
    displaylogo: false,
    modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d'],
  },

  // Time series chart configuration
  timeSeries: {
    layout: {
      ...CHART_DIMENSIONS.LARGE,
      xaxis: { 
        title: "Date", 
        tickangle: -45,
        type: 'date'
      },
      yaxis: { title: "Number of Cases" },
      legend: { 
        orientation: "h", 
        y: -0.2,
        x: 0.5,
        xanchor: 'center'
      },
      margin: { t: 30, l: 60, r: 30, b: 100 },
      hovermode: 'x unified'
    }
  },

  // Pie chart configuration
  pie: {
    layout: {
      showlegend: true,
      legend: { 
        orientation: "v", 
        x: 1.02, 
        y: 0.5, 
        font: { size: 14 } 
      },
      margin: { t: 50, l: 50, r: 200, b: 50 }
    },
    trace: {
      type: "pie",
      hole: 0.4,
      marker: { 
        colors: CHART_COLORS,
        line: { color: '#FFFFFF', width: 2 }
      },
      textinfo: "label+percent",
      textposition: "auto",
      hoverinfo: "label+value+percent"
    }
  },

  // Choropleth map configuration
  choropleth: {
    layout: {
      geo: { 
        scope: "usa",
        projection: { type: "albers usa" },
        showlakes: true,
        lakecolor: 'rgb(255, 255, 255)'
      },
      ...CHART_DIMENSIONS.MAP,
      margin: { t: 50, l: 30, r: 30, b: 30 }
    },
    trace: {
      type: "choropleth",
      locationmode: "USA-states",
      colorscale: [
        [0, "rgb(242,240,247)"],
        [0.2, "rgb(218,218,235)"],
        [0.4, "rgb(188,189,220)"],
        [0.6, "rgb(158,154,200)"],
        [0.8, "rgb(117,107,177)"],
        [1, "rgb(84,39,143)"]
      ],
      reversescale: false,
      marker: { line: { color: 'rgb(180,180,180)', width: 0.5 } },
      colorbar: { 
        title: "Number of Cases",
        titleside: "top",
        thickness: 15,
        len: 0.7
      }
    }
  }
};

// Generate color for category based on index
export const getCategoryColor = (index) => {
  return CHART_COLORS[index % CHART_COLORS.length];
};

// Create common hover template
export const createHoverTemplate = (fields) => {
  return fields.map(field => `<b>${field.label}:</b> %{${field.value}}`).join('<br>') + '<extra></extra>';
};

// Animation configuration
export const animations = {
  fast: { transition: { duration: 300 } },
  smooth: { transition: { duration: 750, easing: 'cubic-in-out' } },
  slow: { transition: { duration: 1200, easing: 'cubic-in-out' } }
};
